// Module
var code = "<div class=\"container log-detail-container\">\n   <shift-role-editor selected-log=\"selectedLog\"></shift-role-editor>\n   <scheduled-shift-editor selected-log=\"selectedLog\"></scheduled-shift-editor>\n   <shift-signin-config selected-log=\"selectedLog\"></shift-signin-config>\n </div>\n";
// Exports
module.exports = code;